<section class="flex flex-col gap-6 lg:gap-10 w-full px-4 lg:px-0 lg:max-w-6xl lg:mx-auto py-6 lg:py-12 faq-section">
  <div class="flex flex-col gap-3 lg:flex-row lg:justify-between lg:items-center">
    <!-- TOTAL -->
    <div class="flex items-center gap-1">
      <span class="text-zinc-800 sb-aggro text-sm font-light">TOTAL</span>
      <span class="text-primary-500 sb-aggro font-light text-sm">{{ totalCount() }}</span>
    </div>

    <!-- 검색창 -->
    <div class="search-box">
      <app-icon name="ic:round-search" class="size-5! text-zinc-400"></app-icon>
      <input type="text" placeholder="검색어를 입력하세요" [value]="query()" (input)="onSearch($event)" />
    </div>
  </div>

  @if (faqs().length === 0) {
  <app-not-found [(query)]="query" [isLoading]="$data.isLoading()">
    <span class="sb-aggro text-zinc-800 text-lg font-light">등록된 FAQ가 없습니다.</span>
  </app-not-found>
  } @else {
  <!-- FAQ 리스트 -->
  <div class="flex flex-col gap-3">
    @for (faq of faqs(); track faq.id) {
    <div class="bg-zinc-50 rounded-xl overflow-hidden border border-zinc-100">
      <button
        (click)="toggleFaq(faq.id)"
        class="cursor-pointer w-full flex items-center gap-3 p-5 text-left transition-colors hover:bg-zinc-100">
        <div class="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center shrink-0">
          <span class="text-white font-bold text-sm">Q</span>
        </div>
        <div class="flex flex-1">
          <p class="text-zinc-800 font-semibold">{{ faq.question }}</p>
        </div>
        <app-icon
          name="material-symbols:chevron-right-rounded"
          class="size-5! text-zinc-800 shrink-0"
          [@rotateChevron]="isOpen(faq.id) ? 'up' : 'down'" />
      </button>

      <!-- 답변 영역 -->
      <div [@expandCollapse]="isOpen(faq.id) ? 'expanded' : 'collapsed'">
        <div class="bg-zinc-50 p-5">
          <div class="flex items-start gap-3">
            <div class="shrink-0 w-8 h-8 bg-zinc-400 rounded-full flex items-center justify-center mt-0.5">
              <span class="text-white font-bold text-sm">A</span>
            </div>
            <div class="flex-1">
              <div
                class="editor-content text-zinc-600 text-sm leading-relaxed"
                [innerHTML]="faq.answer | safeHtml"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>

  <!-- 페이지네이션 -->
  <app-pagination
    [currentPage]="currentPage()"
    [totalPages]="totalPages()"
    (pageChange)="onPageChange($event)"
    class="flex" />
  }
</section>
